export default "__VITE_PUBLIC_ASSET__bdf78e8f__"